module.exports = __webpack_public_path__ + "static/media/sumo-icon-1.870fc7b3.png";